import { render, staticRenderFns } from "./Likelihood.vue?vue&type=template&id=71c3d2c5&scoped=true"
import script from "./Likelihood.vue?vue&type=script&lang=js"
export * from "./Likelihood.vue?vue&type=script&lang=js"
import style0 from "./Likelihood.vue?vue&type=style&index=0&id=71c3d2c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3d2c5",
  null
  
)

export default component.exports